import React, { useState } from "react";
import "../Styles/bank.css";
import banks from "../asset/banks.json";
import TopNav from "../layouts/TopNav";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ReLoginModal from "../components/ReLoginModal";
import BankIcon from "../asset/svg/bankIcon";
import api from "../util/axios";

type Banks = {
  code: string;
  name: string;
};

const Bank = () => {
  const [loading, setLoading] = useState(false);
  const token = window.localStorage.getItem("token");

  const [sign, setSign] = useState({
    bankName: "",
    bankCode: "",
    accountNumber: "",
  });

  const [reLogin, setReLogin] = useState(false);
  const [getBank, setGetBank] = useState<Banks | null>(null);

  const handleChange = ({ target: { name, value } }: any) => {
    const selectedBank = banks.find((bank: any) => bank.name === value);
    console.log("Selected Bank:", selectedBank);
    if (selectedBank) {
      setGetBank(selectedBank);
    }

    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
      bankCode: selectedBank ? selectedBank.code : "",
    }));
  };
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSubmit = (e: any) => {
    console.log(getBank);
    setLoading(true);
    e.preventDefault();

    api
      .post(
        "/settings/bank",
        {
          bankName: getBank?.name,
          bankCode: getBank?.code,
          accountNumber: sign.accountNumber,
        },
        {
          headers: headers,
        }
      )
      .then((res) => {
        // console.log(res.data.data);
        setSign({
          bankName: "",
          bankCode: "",
          accountNumber: "",
        });
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
      })
      .catch((err) => {
        setSign({
          bankName: "",
          bankCode: "",
          accountNumber: "",
        });
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  return (
    <div className="board !bg-gray-100">
      <TopNav title="Bank" />

      {reLogin ? <ReLoginModal /> : null}
      <div className="flex justify-between !h-screen p-10 rounded-lg shadow-lg">
        <div className="p-10 !w-6/12 bg-white">
          <div className="flex justify-between flex-start mb-5 ">
            <h1 className="text-2xl text-blue-600">Register Your preferred Bank</h1>
            <Link to="/dashboard/banktable">
              <button
                style={{
                  width: "480px",
                  height: "40px",
                  borderRadius: "6px",
                  background: "#0b77c5",
                  border: "none",
                  color: "#fff",
                  fontStyle: "normal",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                View Registered Banks
              </button>
            </Link>
          </div>
          <hr />
          <form onSubmit={handleSubmit} className="bankInput mt-12 !w-full">
            <div className="input my-6">
              <label>Bank Name</label>
              <select onChange={handleChange} name="bankName" id="" required className="!w-full cursor-pointer">
                <option value=""></option>
                {banks.map((bank: any, inx: number) => {
                  return <option value={bank.name}>{bank.name}</option>;
                })}
              </select>
            </div>
            <div className="input my-6">
              <label>Account Number</label>
              <input
                className="!w-full"
                type="number"
                required
                name="accountNumber"
                onChange={handleChange}
                value={sign.accountNumber}
              />
            </div>

            {/* <button type="submit">Register Bank</button */}
            <button type="submit" className="w-full bg-blue-500 hover:bg-blue-400 text-white font-semibold my-6 py-2 px-4 rounded">
              {loading ? (
                <CircularProgress
                  style={{ color: "#fff", width: "25px", height: "25px" }}
                />
              ) : (
                "Register Bank"
              )}
            </button>
          </form>
        </div>
        <div style={{ backgroundColor: "#99B4C9" }} className="p-10 w-6/12 flex items-center justify-center">
          <BankIcon />
        </div>
      </div>
    </div>
  );
};

export default Bank;
